import { IKeyValue } from 'shared/interfaces/utils/IKeyValue';

export const arraysEqual = (a: Array<Object>, b: Array<Object>) => {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

const GET_CURRENT_YEAR = new Date().getFullYear();
export const GENERATE_DATES: IKeyValue[] = Array.from({
  length: GET_CURRENT_YEAR - (GET_CURRENT_YEAR - 100),
}).map((_, i) => {
  const value: any = GET_CURRENT_YEAR - i;
  return {
    key: value.toString(),
    value: value,
  };
});

export const getMinorYears = (year: number, to?: number) =>
  Array.from({
    length: GET_CURRENT_YEAR - (GET_CURRENT_YEAR - year + (to || 0)),
  }).map((_, i) => {
    const value = GET_CURRENT_YEAR - i;
    return {
      key: (value - (to || 0)).toString(),
      value: value - (to || 0),
    };
  });

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */

//Source: https://stackoverflow.com/questions/21741841/detecting-ios-android-operating-system

declare const window: any;

export const getMobileOperatingSystem = (): string => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return 'Windows Phone';
  }

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
};

export const imageURLtoFile = async (url: string, filename: string) => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new File([blob], filename, { type: 'image/jpeg' });
};

export const isJsonString = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

export const emailValidation = (email: string) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
};
